import { Graphics, Container, Text, Point, ObservablePoint, Texture, extras } from 'pixi.js'
import helpers from '../helpers'
import { app, grid } from './index'

export default class RoomController extends Container {

  constructor(room) {
    super()

    // 対象の部屋
    this.room = room

    // this.visible = false

    let png = !helpers.methods.useSvg()

    let iconArrorSVG = '/simulator_assets/img/iconArrow.svg'
    if (png) iconArrorSVG = iconArrorSVG.replace('.svg', app.renderer.resolution > 1 ? '_2x.png' : '.png')

    let arrowTexture = new PIXI.Texture.fromImage(iconArrorSVG, false, PIXI.SCALE_MODES.LINEAR, app.renderer.resolution)

    // ↑ボタン
    this.btnTop = new Graphics()
    this.btnTop.beginFill(0x67A7D2, 1);
    this.btnTop.drawCircle(0, 0, 10);
    this.btnTop.cursor = 'n-resize'
    this.btnTopH = new Graphics()
    this.btnTopH.visible = false
    this.btnTopH.beginFill(0xCC3300, 1);
    this.btnTopH.drawCircle(0, 0, 7);
    this.btnTopArrow = new PIXI.Sprite.from(arrowTexture)
    this.btnTopArrow.scale.set(1 / app.renderer.resolution)
    this.btnTopArrow.anchor.set(0.5)
    this.btnTopArrow.rotation = 270 * (Math.PI / 180)
    this.addChild(this.btnTop)
    this.addChild(this.btnTopH)
    this.addChild(this.btnTopArrow)
    this.bindBtnEvents(this.btnTop, this.btnTopH, 'top')

    // ↓ボタン
    this.btnBottom = new Graphics()
    this.btnBottom.beginFill(0x67A7D2, 1);
    this.btnBottom.drawCircle(0, 0, 10);
    this.btnBottom.cursor = 's-resize'
    this.btnBottomH = new Graphics()
    this.btnBottomH.visible = false
    this.btnBottomH.beginFill(0xCC3300, 1);
    this.btnBottomH.drawCircle(0, 0, 7);
    this.btnBottomArrow = new PIXI.Sprite.from(arrowTexture)
    this.btnBottomArrow.scale.set(1 / app.renderer.resolution)
    this.btnBottomArrow.anchor.set(0.5)
    this.btnBottomArrow.rotation = 90 * (Math.PI / 180)
    this.addChild(this.btnBottom)
    this.addChild(this.btnBottomH)
    this.addChild(this.btnBottomArrow)
    this.bindBtnEvents(this.btnBottom, this.btnBottomH, 'bottom')

    // ←ボタン
    this.btnLeft = new Graphics()
    this.btnLeft.beginFill(0x67A7D2, 1);
    this.btnLeft.drawCircle(0, 0, 10);
    this.btnLeft.cursor = 'w-resize'
    this.btnLeftH = new Graphics()
    this.btnLeftH.visible = false
    this.btnLeftH.beginFill(0xCC3300, 1);
    this.btnLeftH.drawCircle(0, 0, 7);
    this.btnLeftArrow = new PIXI.Sprite.from(arrowTexture)
    this.btnLeftArrow.scale.set(1 / app.renderer.resolution)
    this.btnLeftArrow.anchor.set(0.5)
    this.btnLeftArrow.rotation = 180 * (Math.PI / 180)
    this.addChild(this.btnLeft)
    this.addChild(this.btnLeftH)
    this.addChild(this.btnLeftArrow)
    this.bindBtnEvents(this.btnLeft, this.btnLeftH, 'left')

    // →ボタン
    this.btnRight = new Graphics()
    this.btnRight.beginFill(0x67A7D2, 1);
    this.btnRight.drawCircle(0, 0, 10);
    this.btnRight.cursor = 'e-resize'
    this.btnRightH = new Graphics()
    this.btnRightH.visible = false
    this.btnRightH.beginFill(0xCC3300, 1);
    this.btnRightH.drawCircle(0, 0, 7);
    this.btnRightArrow = new PIXI.Sprite.from(arrowTexture)
    this.btnRightArrow.scale.set(1 / app.renderer.resolution)
    this.btnRightArrow.anchor.set(0.5)
    this.addChild(this.btnRight)
    this.addChild(this.btnRightH)
    this.addChild(this.btnRightArrow)
    this.bindBtnEvents(this.btnRight, this.btnRightH, 'right')

    // this.room.on('focus', () => this.focus())
    // this.room.on('blur', () => this.blur())

    this.room.on('drag', () => this.drag())
    this.room.on('drop', () => this.drop())

    this.room.on('updatedimension', () => this.updateDimension())
    this.room.on('updatecoordinate', () => this.updateCoordinate())

    this.updateDimension()
    this.updateCoordinate()

    return this
  }

  updateDimension() {
    this.btnTop.position.set(this.room.calcWidth/2, 0);
    this.btnBottom.position.set(this.room.calcWidth/2, this.room.calcHeight);
    this.btnLeft.position.set(0, this.room.calcHeight/2);
    this.btnRight.position.set(this.room.calcWidth, this.room.calcHeight/2);
    this.btnTopH.position.set(this.room.calcWidth/2, 0);
    this.btnBottomH.position.set(this.room.calcWidth/2, this.room.calcHeight);
    this.btnLeftH.position.set(0, this.room.calcHeight/2);
    this.btnRightH.position.set(this.room.calcWidth, this.room.calcHeight/2);
    this.btnTopArrow.position.set(this.room.calcWidth/2, 0);
    this.btnBottomArrow.position.set(this.room.calcWidth/2, this.room.calcHeight);
    this.btnLeftArrow.position.set(0, this.room.calcHeight/2);
    this.btnRightArrow.position.set(this.room.calcWidth, this.room.calcHeight/2);
  }

  updateCoordinate() {
    this.position.set(this.room.position.x, this.room.position.y)
  }

  focus() {
  }

  blur() {
  }

  drag() {
    this.btnTop.visible = false
    this.btnBottom.visible = false
    this.btnLeft.visible = false
    this.btnRight.visible = false
    this.btnTopArrow.visible = false
    this.btnBottomArrow.visible = false
    this.btnLeftArrow.visible = false
    this.btnRightArrow.visible = false
  }

  drop() {
    this.btnTop.visible = true
    this.btnBottom.visible = true
    this.btnLeft.visible = true
    this.btnRight.visible = true
    this.btnTopArrow.visible = true
    this.btnBottomArrow.visible = true
    this.btnLeftArrow.visible = true
    this.btnRightArrow.visible = true
  }

  bindBtnEvents(btn, btnH, direction) {
    btn.interactive = true
    btn.touching = false
    btn.on('pointerover', e => {
      btnH.visible = true
    })
    btn.on('pointerout', e => {
      if (btn.touching == false) {
        btnH.visible = false
      }
    })
    btn.on('pointerdown', e => {
      btn.touching = true
      e.stopPropagation()

      const startDimension = new Point()
      const startCoordinate = new Point()
      startDimension.copy(this.room.dimension)
      startCoordinate.copy(this.room.coordinate)

      grid.on('pointermove', e => {
        const localPosition = e.data.getLocalPosition(this.parent)
        const pointer = new Point(
          Math.round(localPosition.x / grid.size / (1/grid.division)) * (1/grid.division),
          Math.round(localPosition.y / grid.size / (1/grid.division)) * (1/grid.division),
        )

        const top = startDimension.y + (startCoordinate.y - pointer.y)
        const left = startDimension.x + (startCoordinate.x - pointer.x)
        const right = pointer.x - startCoordinate.x
        const bottom = pointer.y - startCoordinate.y


        switch (direction) {
          case 'top':
            const diffTop = this.room.coordinate.y - pointer.y
            const maxTop = _.max(this.room.items.children.map(item => this.room.dimension.y - item.coordinate.y))
            if (top >= 1 && (maxTop == undefined || top >= maxTop)) {
              this.room.dimension.y = top
              this.room.coordinate.y = pointer.y
              this.room.items.children.forEach(item => {
                item.coordinate.y += diffTop
              })
            }
            break
          case 'left':
            const diffLeft = this.room.coordinate.x - pointer.x
            const maxLeft = _.max(this.room.items.children.map(item => this.room.dimension.x - item.coordinate.x))
            if (left >= 1 && (maxLeft == undefined || left >= maxLeft)) {
              this.room.dimension.x = left
              this.room.coordinate.x = pointer.x
              this.room.items.children.forEach(item => {
                item.coordinate.x += diffLeft
              })
            }
            break
          case 'right':
            const maxRight = _.max(this.room.items.children.map(item => item.coordinate.x + (item.angle % 180 == 0 ? item.area.width : item.area.height) / grid.size))
            if (right >= 1 && (maxRight == undefined || right >= maxRight)) {
              this.room.dimension.x = right
            }
            break
          case 'bottom':
            const maxBottom = _.max(this.room.items.children.map(item => item.coordinate.y + (item.angle % 180 != 0 ? item.area.width : item.area.height) / grid.size))
            if (bottom >= 1 && (maxBottom == undefined || bottom >= maxBottom)) {
              this.room.dimension.y = bottom
            }
            break
        }
      })
      grid.once('pointerup', e => {
        btn.touching = false
        btnH.visible = false
        grid.off('pointermove')
        grid.off('pointerupoutside')
      })
      grid.once('pointerupoutside', e => {
        btn.touching = false
        btnH.visible = false
        grid.off('pointermove')
        grid.off('pointerup')
      })
    })
  }
}



// WEBPACK FOOTER //
// ./assets/js/display/RoomController.js